import { FC } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { leaves } from "~/constants";
import { SomeLogisticsPage } from "~/OnboardingApp/pages/interstitialPages/SomeLogisticsPage";
import { ThanksForSharingPage } from "~/OnboardingApp/pages/interstitialPages/ThanksForSharingPage";
import { WelcomePage } from "~/OnboardingApp/pages/interstitialPages/WelcomePage";
import { BirthdayPage } from "~/OnboardingApp/pages/questionPages/BirthdayPage";
import { ClinicReferPage } from "~/OnboardingApp/pages/questionPages/ClinicReferPage/ClinicReferPage";
import { ClinicSatisfactionPage } from "~/OnboardingApp/pages/questionPages/ClinicSatisfactionPage";
import { CoveragePage } from "~/OnboardingApp/pages/questionPages/CoveragePage";
import { CurrentClinicPage } from "~/OnboardingApp/pages/questionPages/CurrentClinicPage/CurrentClinicPage";
import { DueDatePage } from "~/OnboardingApp/pages/questionPages/DueDatePage";
import { EmailPage } from "~/OnboardingApp/pages/questionPages/EmailPage";
import { EmployerPage } from "~/OnboardingApp/pages/questionPages/EmployerPage";
import { HealthConditionsPage } from "~/OnboardingApp/pages/questionPages/HealthConditionsPage";
import { HowAnxiousPage } from "~/OnboardingApp/pages/questionPages/HowAnxiousPage";
import { HowDidYouHearPage } from "~/OnboardingApp/pages/questionPages/HowDidYouHearPage";
import { HowGratefulPage } from "~/OnboardingApp/pages/questionPages/HowGratefulPage/HowGratefulPage";
import { HowLongPage } from "~/OnboardingApp/pages/questionPages/HowLongPage/HowLongPage";
import { HowOptimisticPage } from "~/OnboardingApp/pages/questionPages/HowOptimisticPage";
import { HowSupportedPage } from "~/OnboardingApp/pages/questionPages/HowSupportedPage";
import { JourneyLooksLikePage } from "~/OnboardingApp/pages/questionPages/JourneyLooksLikePage";
import { MedicalDiagnosisPage } from "~/OnboardingApp/pages/questionPages/MedicalDiagnosisPage";
import { MoreTreatmentDetailsPage } from "~/OnboardingApp/pages/questionPages/MoreTreatmentDetailsPage";
import { MostChallengingPage } from "~/OnboardingApp/pages/questionPages/MostChallengingPage";
import { NamePage } from "~/OnboardingApp/pages/questionPages/NamePage";
import { NextMilestonePage } from "~/OnboardingApp/pages/questionPages/NextMilestonePage";
import { PhonePage } from "~/OnboardingApp/pages/questionPages/PhonePage";
import { PregnancyBackgroundPage } from "~/OnboardingApp/pages/questionPages/PregnancyBackgroundPage";
import { ProvidersSeenPage } from "~/OnboardingApp/pages/questionPages/ProvidersSeenPage";
import { SupportNeedsPage } from "~/OnboardingApp/pages/questionPages/SupportNeedsPage";
import { ZipPage } from "~/OnboardingApp/pages/questionPages/ZipPage";
import { rrPath } from "./utils";

export const OnboardingRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path={rrPath(leaves.interstitialLogistics)}
        element={<SomeLogisticsPage />}
      />
      <Route
        path={rrPath(leaves.interstitialThanksForSharing)}
        element={<ThanksForSharingPage />}
      />
      <Route
        path={rrPath(leaves.interstitialWelcome)}
        element={<WelcomePage />}
      />
      <Route
        path={rrPath(leaves.questionBirthday)}
        element={<BirthdayPage />}
      />
      <Route
        path={rrPath(leaves.questionClinicRefer)}
        element={<ClinicReferPage />}
      />
      <Route
        path={rrPath(leaves.questionClinicSatisfaction)}
        element={<ClinicSatisfactionPage />}
      />
      <Route
        path={rrPath(leaves.questionCoverage)}
        element={<CoveragePage />}
      />
      <Route
        path={rrPath(leaves.questionCurrentClinic)}
        element={<CurrentClinicPage />}
      />
      <Route path={rrPath(leaves.questionDueDate)} element={<DueDatePage />} />
      <Route path={rrPath(leaves.questionEmail)} element={<EmailPage />} />
      <Route
        path={rrPath(leaves.questionEmployer)}
        element={<EmployerPage />}
      />
      <Route
        path={rrPath(leaves.questionHealthConditions)}
        element={<HealthConditionsPage />}
      />
      <Route
        path={rrPath(leaves.questionHowAnxious)}
        element={<HowAnxiousPage />}
      />
      <Route
        path={rrPath(leaves.questionHowDidYouHear)}
        element={<HowDidYouHearPage />}
      />
      <Route
        path={rrPath(leaves.questionHowGrateful)}
        element={<HowGratefulPage />}
      />
      <Route path={rrPath(leaves.questionHowLong)} element={<HowLongPage />} />
      <Route
        path={rrPath(leaves.questionHowOptimistic)}
        element={<HowOptimisticPage />}
      />
      <Route
        path={rrPath(leaves.questionHowSupported)}
        element={<HowSupportedPage />}
      />
      <Route
        path={rrPath(leaves.questionJourneyLooksLike)}
        element={<JourneyLooksLikePage />}
      />
      <Route
        path={rrPath(leaves.questionNextMilestone)}
        element={<NextMilestonePage />}
      />
      <Route
        path={rrPath(leaves.questionMedicalDiagnosis)}
        element={<MedicalDiagnosisPage />}
      />
      <Route
        path={rrPath(leaves.questionSupportNeeds)}
        element={<SupportNeedsPage />}
      />
      <Route
        path={rrPath(leaves.questionMostChallenging)}
        element={<MostChallengingPage />}
      />
      <Route
        path={rrPath(leaves.questionClinicSatisfaction)}
        element={<ClinicSatisfactionPage />}
      />

      <Route path={rrPath(leaves.questionName)} element={<NamePage />} />
      <Route
        path={rrPath(leaves.questionMoreTreatmentDetails)}
        element={<MoreTreatmentDetailsPage />}
      />
      {/* Legacy redirect: the partner question was retired in favor of
          more-treatment-details. Keep existing /onboarding/partner URLs working
          during rollout so in-flight sessions and hard refreshes don't 404. */}
      <Route
        path={rrPath(leaves.questionPartner)}
        element={
          <Navigate
            replace={true}
            to={rrPath(leaves.questionMoreTreatmentDetails)}
          />
        }
      />
      <Route path={rrPath(leaves.questionPhone)} element={<PhonePage />} />
      <Route
        path={rrPath(leaves.questionPregnancyBackground)}
        element={<PregnancyBackgroundPage />}
      />
      <Route
        path={rrPath(leaves.questionProvidersSeen)}
        element={<ProvidersSeenPage />}
      />
      <Route path={rrPath(leaves.questionZip)} element={<ZipPage />} />
    </Routes>
  );
};
